import { Checkbox, Flex, Icon, Image, Td, Text, Tr, Button } from '@chakra-ui/react'
import { formatDate } from '../../../../../utils/formatDate'
import { GrUpdate } from 'react-icons/gr'
import { ConfirmDialog } from '../ConfirmDialog'
import { api } from '../../../../../services/api'
import { useState } from 'react'
import { RemoverNota } from '../RemoverNota'
const loading_green = '/images/loading-verde.gif'

export function TrItem({ data, loading, idx, resultado, getNotasAntecipadas }) {
  const [loadingUpdate, setLoadingUpdate] = useState(false)

  async function handleNotaAntecipada(codprod, nunota, sequencia, value) {
    const params = {
      codigo_produto: codprod,
      numero_nota: nunota,
      sequencia: sequencia,
      // codUsu: user.codigo_usuario,
      // nota_antecipada: value,
    }

    const response = await api.post('/site/v2/pedido/atualiza-pendencia-nota-antecipada', params)

    console.log('params: ', params)
    console.log('response: ', response)

    getNotasAntecipadas()

    resultado({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })
  }

  async function updatePeso(nunota, peso) {
    setLoadingUpdate(true)

    console.log('nunota: ', nunota, peso)
    await new Promise((resolve) => setTimeout(resolve, 1000))

    const response = await api.post('/site/v2/pedido/atualiza-peso-info-nota', {
      numero_nota: nunota,
      peso: peso,
    })

    console.log('response: ', response)

    resultado({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })

    setLoadingUpdate(false)
  }

  const objectColor = {
    S: 'green',
    N: 'red',
  }

  //data_saida não pode ser maior que 31/12/2024

  //const bloquearEmissaoNota = new Date(data.data_saida) > new Date('2024-12-31T00:00:00.000Z')
  const bloquearEmissaoNota = false

  // const numInnosBloqueados = ['187296', '184478', '186786']

  // const bloquearEmissaoNota = numInnosBloqueados.includes(data.numero_pedido)

  return (
    <Tr id="id_tr" key={data.numero_unico}>
      <Td bgColor={bloquearEmissaoNota && 'red.200'} color={bloquearEmissaoNota && 'white'} padding=".3rem" textAlign="center">
        <Text as="a" href={data.link_layout} target="_blank" rel="noreferrer" color={'blue.500'} textDecoration="underline" cursor="pointer">
          {data.numero_pedido}
        </Text>
      </Td>

      <Td bgColor={bloquearEmissaoNota && 'red.200'} color={bloquearEmissaoNota && 'white'} padding=".3rem" textAlign="center">
        {data.numero_unico_origem}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        <Button
          href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data.numero_unico}`}
          target="_blank"
          rel="noreferrer"
          as="a"
          colorScheme="blue"
          size="sm"
        >
          Visualizar
        </Button>
      </Td>

      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        {new Date(data.data_saida).toLocaleDateString('pt-BR', {
          timeZone: 'UTC',
        })}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        {formatDate(data.data_emissao_nota)}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '190px' }}
      >
        <Text as="p" noOfLines={1} style={{ textAlign: 'left' }}>
          {data.nome_parc.length > 20 ? data.nome_parc.slice(0, 20) + '...' : data.nome_parc}
        </Text>
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        {data.nome_vendedor}
      </Td>
      {/* <Td bgColor={bloquearEmissaoNota && 'red.200'} color={bloquearEmissaoNota && 'white'} padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        {data.peso_total} kg
      </Td> */}
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        {data.peso_real} kg
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '190px' }}
      >
        {data.quantidades_caixa}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '190px' }}
      >
        {data.transportadora.length > 20 ? data.transportadora.slice(0, 20) + '...' : data.transportadora}
      </Td>

      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '110px' }}
        color={bloquearEmissaoNota ? 'white' : objectColor[data.existe_remessa]}
      >
        {data.existe_remessa === 'S' ? 'Sim' : 'Não'}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '110px' }}
        color={bloquearEmissaoNota ? 'white' : objectColor[data.valida_st]}
      >
        {data.valida_st === 'S' ? 'Sim' : 'Não'}
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '110px' }}
      >
        <Button size="sm" onClick={() => updatePeso(data.numero_unico, data.peso_real)}>
          Frete
          <Icon
            ml={1}
            as={GrUpdate}
            color="#378BBF"
            fontSize="12px"
            cursor="pointer"
            transform={loadingUpdate ? 'rotate(360deg)' : ''}
            transition={loadingUpdate ? 'all 1s' : ''}
          />
        </Button>
      </Td>
      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '110px' }}
        color={bloquearEmissaoNota ? 'white' : objectColor[data.valida_nf]}
      >
        {data.valida_nf === 'S' ? 'Sim' : 'Não'}
      </Td>

      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ position: 'relative', width: '160px' }}
      >
        R${' '}
        {data.valor_nota.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}
      </Td>

      <Td
        bgColor={bloquearEmissaoNota && 'red.200'}
        color={bloquearEmissaoNota && 'white'}
        padding=".3rem"
        textAlign="center"
        style={{ width: '100px', posiotion: 'relative' }}
      >
        {data.status_pendencia === 'S' ? (
          loading === idx ? (
            <Image mx="auto" src={loading_green} h="30px" w="auto" />
          ) : (
            <>
              <ConfirmDialog bloquearEmissao={bloquearEmissaoNota} item={data} resultado={resultado} />
            </>
          )
        ) : (
          <p>{data.data_finalizacao}</p>
        )}
      </Td>

      <Td bgColor={bloquearEmissaoNota && 'red.200'} color={bloquearEmissaoNota && 'white'} textAlign="center">
        <Checkbox
          colorScheme="blue"
          size="lg"
          defaultIsChecked={data.nota_antecipada === 'S' ? true : false}
          sx={{
            borderColor: 'blue.500',
          }}
          onChange={(e) => {
            handleNotaAntecipada(data.codigo_produto, data.numero_unico, data.sequencia, e.target.checked)
          }}
        />
      </Td>
      <Td>
        <RemoverNota item={data} resultado={resultado} />
      </Td>
    </Tr>
  )
}
